import 'jquery.marquee';

$(document).ready(function($) {

	$('.marquee').marquee({
		startVisible: true,
	});

});
